import { Injectable } from '@angular/core';
import { OrderPayStore } from '../stores/order-pay.store';
import { NavController } from '@ionic/angular';
import { CustomerFlow } from '../pages/v2-order-pay/models/customer-flow.model';
import { AnalyticsService } from './analytics.service';
import { IOrderMenuItem } from '../pages/v2-order-pay/models/order-menu.models';
import { ItemDetailsStore } from 'stores/item-details.store';
import { AdyenService } from './adyen.service';
import { LocationStore } from 'stores/location.store';
import { PaymentProvider } from '../pages/v2-order-pay/models/payment.model';
import { FullScreenLoadingService } from './full-screen-loading.service';
import { DemoCheckService } from './demo-check.service';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  constructor(
    private navController: NavController,
    private orderPayStore: OrderPayStore,
    private analyticsService: AnalyticsService,
    private itemDetailsStore: ItemDetailsStore,
    private locationStore: LocationStore,
    private adyenService: AdyenService,
    private fullScreenLoadingService: FullScreenLoadingService,
    private demoCheckService: DemoCheckService
  ) {}

  goToV2Components(): Promise<boolean> {
    return this.navController.navigateForward([
      '/',
      this.orderPayStore.beaconId,
      'v2',
      'components'
    ]);
  }

  goToCheckHelp(): Promise<boolean> {
    return this.navController.navigateForward([
      '/',
      this.orderPayStore.beaconId,
      'v2',
      'no-check-help'
    ]);
  }

  reportMismappedTarget(): Promise<boolean> {
    return this.navController.navigateForward([
      '/',
      this.orderPayStore.beaconId,
      'v2',
      'report-mismapped-target'
    ]);
  }

  async goToYourBillPage(currentFlow: CustomerFlow): Promise<boolean> {
    this.loadAdyenPaymentProvidersIfNecessary();

    this.orderPayStore.setCurrentFlow(currentFlow);
    this.analyticsService.trackInitiateCheckout();
    return this.navController.navigateForward([
      '/',
      this.orderPayStore.beaconId,
      'v2',
      'your-bill'
    ]);
  }

  viewItemDetailsPage(item: IOrderMenuItem): Promise<boolean> {
    this.itemDetailsStore.selectedItemId = item.id;
    return this.navController.navigateForward([
      '/',
      this.orderPayStore.beaconId,
      'v2',
      'order',
      'item-details'
    ]);
  }

  goToAccountPage(): Promise<boolean> {
    return this.navController.navigateForward('/account');
  }

  private async loadAdyenPaymentProvidersIfNecessary() {
    // DEMO-ONLY (see DemoCheckService): skip Adyen's eager payment-method fetch.
    // It calls getPaymentMethods against the fabricated invoice, which fails and
    // leaves the full-screen loader up (the hide call below never runs), blocking
    // checkout. The demo pay button doesn't use any real provider anyway.
    if (this.demoCheckService.isActive) {
      return;
    }

    if (
      this.locationStore.currentLocation?.paymentProcessor.provider ===
      PaymentProvider.Adyen
    ) {
      this.fullScreenLoadingService.showFullScreenLoader();
      await this.adyenService.initializePaymentOptions();
      this.fullScreenLoadingService.hideFullScreenLoader();
    }
  }
}
